import { Translations } from './en';

const fr: Translations = {
  title: 'Détection de la fraude',
  subtitle: 'Paramétrez vos modèles de lutte anti-fraude',
  downloadDocuments: 'Ajouter des documents',
  metadata: 'Métadonnées',
  table: {
    name: 'Nom',
    risk: 'Risque',
    score: 'Score',
    status: 'Statut',
  },
  dropdown: {
    details: 'Détails',
    download: 'Téléchargement',
    downloadReport: 'Télécharger le rapport',
    delete: 'Supprimer',
  },
  levelStates: {
    low: 'Faible',
    medium: 'Moyen',
    high: 'Haut',
    unknown: 'Inconnu',
  },
  riskOverviewTitle: 'Analyse de risque du document {{name}}',
  sensitivitySettings: {
    modalTitle: 'Configuration de la sensibilité',
    modalOpenButton: 'Configurer la sensibilité du modèle',
    submitSettingsButton: 'Modifier',
    cancelSettingsButton: 'Annuler',
    seuilChangementAlignement: 'Inclinaison par rapport au texte original',
    seuilDifferenceEspace: "Taille de l'espace entre les mots",
    seuilDifferenceCouleur: 'Différence de couleur de fond',
    metadataKeywords: 'Nombre d\'occurrences de mots-clés figurant sur la liste noire dans les métadonnées',
    metadataKeywordsBlacklist: 'Mots clés dans les métadonnées',
    numberOfDays: 'Nombre de jours écoulés depuis la dernière modification du document',
    minimumLayer: 'Nombre minimum de couches dans le document',
    size: 'Différence de taille du texte',
    font: 'Police',
  },
  assessmentList: {
    emptyListText: "Pas de données à l'appui",
    elementHeader: 'Element',
    valueHeader: 'Valeur',
  },
  imageNotFound: 'Image non trouvée',
  assessmentTypes: {
    Size: 'Taille des polices',
    Spacing: 'Espacements',
    Colorimetry: 'Colorimétrie',
    MetadataKeywords: 'Contrôle des métadonnées',
    Font: 'Contrôle des polices',
    Parallelism: 'Parallélisme',
  },
};

export default fr;
